import api from '../api';

import { ParamsDataPlatformsWithPolicy } from 'utils/typeServices';

export const GetPlatformsWithPolicy = async ({ token }: { token: string }) => {
    try {
        const { data } = await api.get<{ Data: Array<ParamsDataPlatformsWithPolicy> }>('v1/Plataforma/GetPlatformsWithPolicy', {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
